import path from 'path-browserify';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
export const useSubAppNavigationListener = (subAppPath, rootPath) => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!subAppPath)
            return;
        const nextPath = path.join(rootPath, subAppPath);
        navigate(nextPath);
        // 'navigate' is omitted, as it causes the effect to run additional times,
        // which produces undesirable results (ie infinite looping)
    }, [subAppPath, rootPath]);
};
